<div class="avatar" [ngStyle]="{ 'background-color': backgroundColor }">
    {{ initial }}
</div>